import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "M7 22V2l10 5-10 5", stroke: `${color}` })
    }
  );
};
Icon.displayName = "FlagTriangleRight";
const FlagTriangleRight = memo(themed(Icon));
export {
  FlagTriangleRight
};
//# sourceMappingURL=flag-triangle-right.js.map
